import { supabase } from "@/integrations/supabase/client";
import { debug } from "@/lib/debug";

type SolanaPublicConfigPayload = {
  tritonRpcUrl?: string | null;
  tritonWsUrl?: string | null;
};

declare global {
  interface Window {
    __SOLANA_PUBLIC_CONFIG__?: {
      tritonRpcUrl?: string;
      tritonWsUrl?: string;
    };
  }
}

/**
 * Loads Solana public config from backend runtime secrets into
 * `window.__SOLANA_PUBLIC_CONFIG__` so the client can use it even when
 * Vite build-time env vars aren't injected.
 */
export async function loadSolanaRuntimeConfig(): Promise<void> {
  try {
    const { data, error } = await supabase.functions.invoke<SolanaPublicConfigPayload>(
      "solana-public-config",
      { method: "GET" }
    );

    if (error || !data) {
      console.warn("[Solana Config] Failed to load runtime config:", error);
      return;
    }
    if (typeof window === "undefined") return;

    if (data.tritonRpcUrl || data.tritonWsUrl) {
      window.__SOLANA_PUBLIC_CONFIG__ = {
        tritonRpcUrl: data.tritonRpcUrl ?? undefined,
        tritonWsUrl: data.tritonWsUrl ?? undefined,
      };
      debug.trace("[Solana Config] Runtime config loaded successfully");
    }
  } catch (err) {
    console.warn("[Solana Config] Runtime config load error:", err);
    // no-op (config will remain unset, fallback to env vars)
  }
}
